import { Card } from 'antd';
import Styled from 'styled-components';

const PaymentCardWrapper = Styled.div`
display: flex;
align-items: center;
gap: 1.5rem;


width: 100% !important;
@media (max-width: 768px) {
  flex-direction: column;
  width: 100% !important;
}
   
`;

const PaymentMethodSection = Styled.div`
// border-bottom: 2px solid #f0f0f0;
// .ant-card-head{
// padding: 0 !important;
// margin-left:-15px !important;
// margin-right: -15px !important;
//  border-bottom: 2px solid rgba(242, 242, 242, 1) !important;
// }
// .ant-card-body{
// padding: 15px 0px !important;
// }

display: flex;
flex-direction: column;
gap: 25px;
min-height: 16rem;

.heading{
margin-left:-25px !important;
margin-right: -25px !important;
 border-bottom: 2px solid rgba(242, 242, 242, 1) !important;
 padding:  18px 25px !important;
//  border: 1px solid red;
 color: rgb(10, 10, 10);
 font-weight: 600;
 font-size: 18px;
}
`;
const PaymentCardCont = Styled(Card)`

position: relative;


width: 25rem !important;

height: 7rem !important;
display: flex;
align-items: center;  
padding: 25px 0 !important;
cursor: ${(props) => (props.$clickable ? 'pointer' : 'default')};
@media (max-width: 768px) {
  
  width: 100% !important;
  // padding: 15px 0 !important;
}  
  @media (max-width: 574px) {
  // padding: 15px 0 !important;4
  height: auto !important;
 
}  

button {
    background: none;
    border: none;
     cursor: ${(props) => (props.status === 'pending' ? 'pointer' : 'default')} !important;
    outline: none;
   

}
    .mobile-info-button{
        // display: none;
        @media (max-width: 768px) {
            position: absolute !important;
            top: 0 !important;
            right: 10px !important;
        }
    }

box-shadow: 0px 12px 25px 0px rgba(0, 0, 0, 0.1) !important;


.ant-card-body{
    ::before, ::after{
        content: none !important;
        display: none !important;   
    }
    // padding: 15px 25px !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    width: 100%;  
    @media (max-width: 574px) {
  // padding: 15px 0 !important;
  flex-direction: column !important;
  height: auto !important;
 
}    
    }

    .card-content-right{
        display: flex;
        align-items: center;
        gap: 1rem;
        width: 100%;
    }   


`;

// rgba(195, 255, 212, 1)

const StatusButton = Styled.span`
text-align: center; 
padding: 8px 18px;
border-radius: 10rem;
flex:1;
     cursor: ${(props) => (props.status === 'pending' ? 'pointer' : 'default')} !important;
background-color: ${(props) => {
  switch (props.status) {
    case 'pending':
      return 'rgba(255, 238, 198, 1)';
    case 'connected':
      return 'rgba(195, 255, 212, 1)';
    case 'rejected':
      return 'rgba(255, 0, 0, 1)';
    case 'in-progress':
      return 'rgba(255, 255, 0, 1)';
    default:
      return '#ccc';
  }
}};
color: ${(props) => {
  switch (props.status) {
    case 'pending':
      return 'rgba(255, 157, 0, 1)';
    case 'connected':
      return 'rgba(38, 200, 1, 1)';
    case 'rejected':
      return '#fff';
    case 'in-progress':
      return '#000';
    default:
      return '#000';
  }
}};
`;

export { PaymentCardCont, PaymentCardWrapper, StatusButton, PaymentMethodSection };
